import type { ComponentType, ReactNode, SVGProps } from "react";
import { tv } from "tailwind-variants";

const cardHeader = tv({
  slots: {
    root: "flex items-center justify-between",
    left: "flex items-center gap-3",
    icon: "shrink-0 text-text-primary",
    title: "text-base font-semibold text-text-primary",
  },
});

interface SectionHeaderProps {
  readonly title: ReactNode;
  readonly icon?: ComponentType<SVGProps<SVGSVGElement>>;
  readonly iconSize?: number;
  readonly action?: ReactNode;
  readonly className?: string;
}

export function SectionHeader({
  title,
  icon: Icon,
  iconSize = 20,
  action,
  className,
}: SectionHeaderProps) {
  const { root, left, icon, title: titleClass } = cardHeader();

  return (
    <div className={root({ className })}>
      <div className={left()}>
        {Icon && <Icon width={iconSize} height={iconSize} className={icon()} />}
        <h3 className={titleClass()}>{title}</h3>
      </div>
      {action !== undefined && <div className="shrink-0">{action}</div>}
    </div>
  );
}
